import { render, staticRenderFns } from "./storage-media.vue?vue&type=template&id=25f23cbc&"
import script from "./storage-media.vue?vue&type=script&lang=js&"
export * from "./storage-media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports